import { Injectable } from '@angular/core';

declare const window: any;
declare const Insider: any;

export enum InsiderPageType {
  CONFIRMATION = 'Confirmation',
}

@Injectable({
  providedIn: 'root'
})
export class InsiderTagService {
  private storageKey = 'ptid';

  constructor() { }

  initializeCheckoutPage(pageType: string, transactionId: string): void {
    console.log('Checkout Page ID', transactionId);
    console.log('Checkout Page already opened:', this.isTransactionProcessed(transactionId));

    if (!this.isTransactionProcessed(transactionId)) {
      console.log('Setting insider_object.page:', pageType);
      window.insider_object = window.insider_object || {};
      window.insider_object.page = {
        type: pageType,
      };

      this.reInitializeInsider();
      this.markTransactionAsProcessed(transactionId);
    }
  }

  reInitializeInsider(): void {
    if (typeof Insider !== 'undefined') {
      Insider.eventManager.dispatch('init-manager:re-initialize');
      console.log('Insider Tag re-inicializada.');
    } else {
      console.warn('Insider Tag não está disponível.');
    }
  }

  isTransactionProcessed(transactionId: string): boolean {
    const processedIds = this.getProcessedTransactionIds();
    return processedIds.includes(transactionId);
  }

  markTransactionAsProcessed(transactionId: string): void {
    const processedIds = this.getProcessedTransactionIds();
    processedIds.push(transactionId);
    sessionStorage.setItem(this.storageKey, JSON.stringify(processedIds));
  }

  getProcessedTransactionIds(): string[] {
    const data = sessionStorage.getItem(this.storageKey);
    return data ? JSON.parse(data) : [];
  }

  clearPageObject(): void {
    if (window.insider_object && window.insider_object.page) {
      delete window.insider_object.page;
      console.log('insider_object.page object removed.');
    }
  }
}
